import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AlertTriangle } from "lucide-react";

interface ClearExpensesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  onExport: () => void;
  isLoading?: boolean;
  expenseCount: number;
}

export const ClearExpensesDialog = ({
  open,
  onOpenChange,
  onConfirm,
  onExport,
  isLoading,
  expenseCount,
}: ClearExpensesDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-destructive">
            <AlertTriangle className="h-5 w-5" />
            Clear All Expenses?
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <p>
              <strong className="text-foreground">Warning:</strong> This will permanently delete{" "}
              <strong className="text-foreground">{expenseCount} expense{expenseCount !== 1 ? 's' : ''}</strong>.
              This action cannot be undone.
            </p>
            <p className="text-muted-foreground">
              Unlike earnings which can be re-imported from Turo, expenses you entered manually 
              will be <strong>permanently lost</strong>.
            </p>
            <p className="text-primary font-medium">
              Please export your expenses to a CSV file before clearing to keep a backup.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col sm:flex-row gap-2">
          <AlertDialogCancel disabled={isLoading}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault();
              onExport();
            }}
            className="bg-secondary text-secondary-foreground hover:bg-secondary/80"
          >
            Export First
          </AlertDialogAction>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isLoading}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isLoading ? "Clearing..." : "Clear All Expenses"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
